.sidebar {
  background: var(--ink);
  color: rgba(255, 255, 255, .85);
  padding: 18px 16px 22px;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.brand {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 4px 6px 16px;
}

.brandMark {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
}

.brandName {
  font-family: var(--display);
  font-weight: 900;
  font-size: 18px;
  letter-spacing: -0.8px;
  color: #fff;
  line-height: 1;
}

.brandName em {
  font-style: italic;
  color: var(--orange);
  letter-spacing: -1px;
}

.brandName b {
  color: var(--orange);
  font-weight: 900;
}

.brandTag {
  margin-left: auto;
  padding: 2px 6px;
  border-radius: 4px;
  background: rgba(255, 122, 26, .16);
  color: var(--orange);
  font-family: var(--mono);
  font-size: 9.5px;
  font-weight: 600;
  letter-spacing: 0.8px;
}

/* Role switcher segmented */
.roleSwitch {
  background: rgba(255, 255, 255, .06);
  border: 1px solid rgba(255, 255, 255, .08);
  border-radius: 12px;
  padding: 4px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3px;
  margin: 6px 0 18px;
}

.roleBtn {
  border: 0;
  background: transparent;
  color: rgba(255, 255, 255, .55);
  padding: 9px 8px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: all .15s;
  cursor: pointer;
}

.roleBtn:hover:not(.active) {
  color: rgba(255, 255, 255, .85);
  background: rgba(255, 255, 255, .03);
}

.roleBtnActiveNutri {
  background: var(--green);
  color: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, .16);
}

.roleBtnActiveCoach {
  background: var(--orange);
  color: var(--ink);
  box-shadow: 0 1px 3px rgba(0, 0, 0, .16);
}

.navSection {
  font-family: var(--mono);
  font-size: 9.5px;
  font-weight: 600;
  letter-spacing: 1.4px;
  color: rgba(255, 255, 255, .4);
  text-transform: uppercase;
  padding: 12px 6px 6px;
}

.nav {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.navItem {
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 8px 10px;
  border-radius: 8px;
  color: rgba(255, 255, 255, .7);
  font-size: 13.5px;
  font-weight: 500;
  letter-spacing: -0.1px;
  text-decoration: none;
  cursor: pointer;
  transition: background .12s;
}

.navItem:hover {
  background: rgba(255, 255, 255, .04);
  color: #fff;
}

.navItemActive {
  background: rgba(255, 255, 255, .08);
  color: #fff;
}

.navItemActive svg {
  opacity: 1;
  color: var(--role-accent);
}

.navItem svg {
  flex-shrink: 0;
  opacity: .8;
}

.navBadge {
  margin-left: auto;
  font-family: var(--mono);
  font-size: 10px;
  font-weight: 600;
  background: rgba(255, 255, 255, .1);
  color: rgba(255, 255, 255, .8);
  padding: 2px 6px;
  border-radius: 4px;
  line-height: 1.4;
}

.navBadgeAlert {
  background: var(--orange);
  color: var(--ink);
}

.sidebarFooter {
  margin-top: auto;
  padding-top: 16px;
  border-top: 1px solid rgba(255, 255, 255, .08);
}

.userCard {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 6px;
}

.userAvatar {
  width: 32px;
  height: 32px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--display);
  font-weight: 800;
  font-size: 12px;
  color: #fff;
  background: var(--role-accent);
  flex-shrink: 0;
}

body[data-role='coach'] .userAvatar {
  color: var(--ink);
}

.userInfo {
  flex: 1;
  min-width: 0;
}

.userName {
  font-size: 12.5px;
  font-weight: 600;
  color: #fff;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.userRole {
  font-family: var(--mono);
  font-size: 10px;
  color: rgba(255, 255, 255, .5);
  margin-top: 2px;
  letter-spacing: 0.4px;
  text-transform: uppercase;
}
